// frontend/src/components/handbook/HandbookHeader.js
import React from "react";
import { Link } from "react-router-dom";
import { Search, Menu, ChevronRight } from "lucide-react";

const HandbookHeader = ({
  handbook,
  currentChapter,
  progressForCurrent,
  onSearchClick,
  onMobileMenuClick,
}) => {
  const total = progressForCurrent?.total || 0;
  const done = progressForCurrent?.done || 0;
  const pct = total > 0 ? Math.round((done / total) * 100) : 0;

  return (
    <div className="sticky top-0 z-30 bg-white/90 backdrop-blur border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="h-14 flex items-center gap-3">
          {/* Mobile menu button */}
          <button
            type="button"
            onClick={onMobileMenuClick}
            aria-label="Navigation öffnen"
            className="md:hidden p-2 -ml-2 rounded-md hover:bg-gray-100 text-[#002855]"
          >
            <Menu className="w-5 h-5" />
          </button>

          {/* Breadcrumbs */}
          <nav
            aria-label="Breadcrumb"
            className="flex items-center text-sm min-w-0 flex-1"
          >
            <Link
              to="/coach-handbook"
              className="text-[#002855] hover:text-[#00A3E0] font-semibold truncate"
            >
              {handbook?.title || "Coach Handbook"}
            </Link>
            {currentChapter && (
              <>
                <ChevronRight className="w-4 h-4 text-gray-300 flex-shrink-0 mx-1" />
                <span className="hidden sm:inline text-gray-500 truncate">
                  {currentChapter.section_title}
                </span>
                <ChevronRight className="hidden sm:inline w-4 h-4 text-gray-300 flex-shrink-0 mx-1" />
                <span className="text-gray-700 truncate">
                  {currentChapter.title}
                </span>
              </>
            )}
          </nav>

          {/* Search trigger */}
          <button
            type="button"
            onClick={onSearchClick}
            className="flex items-center gap-2 px-3 py-1.5 rounded-md border border-gray-200 hover:border-gray-300 hover:bg-gray-50 text-sm text-gray-500 transition-colors flex-shrink-0"
            aria-label="Suchen (Cmd+K)"
          >
            <Search className="w-4 h-4" />
            <span className="hidden sm:inline">Suchen</span>
            <span className="hidden md:inline-flex items-center gap-0.5 ml-2 text-xs">
              <kbd className="px-1 py-0.5 bg-white border border-gray-300 rounded font-mono text-gray-600">
                ⌘
              </kbd>
              <kbd className="px-1 py-0.5 bg-white border border-gray-300 rounded font-mono text-gray-600">
                K
              </kbd>
            </span>
          </button>
        </div>

        {/* Sticky progress bar (only inside chapter with checklists) */}
        {currentChapter && total > 0 && (
          <div className="pb-2 -mt-1">
            <div className="flex items-center justify-between text-xs text-gray-500 mb-1">
              <span>
                {done} / {total} erledigt
              </span>
              <span>{pct}%</span>
            </div>
            <div className="h-1 bg-gray-100 rounded-full overflow-hidden">
              <div
                className="h-full bg-[#84BD00] transition-all duration-300"
                style={{ width: `${pct}%` }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HandbookHeader;
